// extracted by mini-css-extract-plugin
export default {"extended":"qU29Vz","title":"_ikiaY","container":"aTL2oX","theme-dark":"H13C9G"};